import styled from "styled-components";
export const BreadcrumbItemContainer = styled.li.withConfig({
  displayName: "breadcrumbstyles__BreadcrumbItemContainer",
  componentId: "sc-1job6iu-0"
})(["", " ", " &:last-child{", "}&:not(:last-child){", "}"], ({
  clickable
}) => clickable && {
  cursor: "pointer"
}, {
  display: "inline-flex",
  textTransform: "uppercase"
}, {
  color: "var(--secondaryColor)"
}, {
  color: "var(--tertiaryColor)"
});
export const BreadcrumbContainer = styled.ul.withConfig({
  displayName: "breadcrumbstyles__BreadcrumbContainer",
  componentId: "sc-1job6iu-1"
})(["", " ", "+", ":before{content:'>';", "}"], {
  listStyleType: "none",
  cursor: "default",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  verticalAlign: "middle",
  alignSelf: "center",
  fontSize: "0.75rem",
  lineHeight: "1rem"
}, BreadcrumbItemContainer, BreadcrumbItemContainer, {
  paddingLeft: "0.25rem",
  paddingRight: "0.25rem",
  "--tw-text-opacity": "1",
  color: "rgba(42, 57, 78, var(--tw-text-opacity))",
  fontWeight: "700"
});
